import React, { useEffect } from "react";
import "./buzondenuncias.css";
import { buzondenuncias} from "../../json/buzondenuncias";
import { Link } from 'react-router-dom';

const Buzondenuncias = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const linkStyle = {
    textDecoration: "none",
  };
   return (
     <>
       <div className="container convocatoria-container">
       <div className='row'>
             <div className='col_12'>
                 <div className='convocatoria_title'>
                     <h1>Denuncias SADERH</h1>
                 </div>
             </div>
             <div class="card text-center">
  <div class="card-header">
  </div>
  <div class="card-body">
    <a href="#" class="btn btn-primary">Buzón de Denuncias SADERH</a>
  </div>
  <div class="card-footer text-muted">
  </div>
</div>
         </div>
       <div className="row">  
          <div className="container interes-container">
               <div className="row">
                 <div className="col_6">
                   <div className="interes_title">
                     <img className="imgHonradez" src=" https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Etica/BuzonDenuncias.jpeg" />
                   </div>
                   {/* <div className="row">
                 {buzondenuncias.map((item, index) => (
                   <div key={index} className="col-md-12 interes-card">
                     <Link style={linkStyle} to={item.url}>
                     <div className='interes_container'>
                             <div className='interes_icono'>
                               <img src={"/img/icons/" + item.icon }/>
                             </div>
                             <h3>{ item.nombre }</h3>
                           </div>
                     </Link>
                   </div>
                 ))}
               </div>   */}

     
                 </div>
               </div>
               
             </div>
       </div>
               
 
         {/* <a className='convocatoria_historicas' href="" >Consulta, Descarga y llena los Anexos requeridos para ingresar una solicitud</a> */}
       </div>
      
     </>
   );
 };
 
 export default Buzondenuncias;
 